import React, { useState, useEffect } from 'react';
import { ToggleInterest } from "../../services/backend";
import { CheckIfInterestExist } from "../../services/backend";
import { Button, useColorModeValue } from '@chakra-ui/react';
import { Sparkles } from 'lucide-react';

const SELECTED_GRADIENT =
  'linear-gradient(to right, var(--chakra-colors-brand-500), var(--chakra-colors-brand-300))';
const SELECTED_GRADIENT_HOVER =
  'linear-gradient(to right, var(--chakra-colors-brand-400), var(--chakra-colors-brand-200))';

const InterestEditPill = ({ interest, updateState, initialSelected }) => {
    const user = JSON.parse(localStorage.getItem('user'));
    const userId = user.id;
    const data = { UserId: userId, InterestName: interest };
    const [isSelected, setIsSelected] = useState(Boolean(initialSelected));
    const idleBg = useColorModeValue('gray.100', 'whiteAlpha.100');
    const idleColor = useColorModeValue('gray.700', 'whiteAlpha.900');
    const idleBorder = useColorModeValue('gray.200', 'whiteAlpha.200');

    useEffect(() => {
        if (initialSelected != null) {
            setIsSelected(Boolean(initialSelected));
            return;
        }
        CheckInterest();
    }, [interest, initialSelected]);

    async function CheckInterest() {
        try {
            const result = await CheckIfInterestExist(data);
            setIsSelected(result === true || result?.exists === true);
        } catch (e) {
            console.log(e.message);
        }
    }

    const handleClick = async () => {
        try {
            const selected = await ToggleInterest(data);
            setIsSelected(selected === true || selected?.exists === true);
            updateState(interest);
        } catch (error) {
            console.error('Error toggling interest:', error);
        }
    };

    return (
        <Button
            onClick={handleClick}
            size="sm"
            borderRadius="full"
            px={4}
            py={2}
            fontSize="sm"
            fontWeight="medium"
            transition="all 0.2s"
            _hover={{
                transform: "translateY(-1px)",
                boxShadow: "sm"
            }}
            _active={{
                transform: "translateY(0)"
            }}
            bg={isSelected ? 'transparent' : idleBg}
            color={isSelected ? 'gray.900' : idleColor}
            border={isSelected ? 'none' : '1px solid'}
            borderColor={isSelected ? 'transparent' : idleBorder}
            position="relative"
            overflow="hidden"
            boxShadow={isSelected ? '0 2px 10px rgba(52,211,153,0.28), 0 0 14px rgba(253,224,71,0.12)' : 'none'}
            sx={{
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: isSelected ? SELECTED_GRADIENT : 'transparent',
                    opacity: isSelected ? 1 : 0,
                    transition: 'opacity 0.2s',
                    zIndex: 0,
                },
                '&:hover::before': {
                    background: isSelected ? SELECTED_GRADIENT_HOVER : SELECTED_GRADIENT,
                    opacity: isSelected ? 1 : 0.12,
                },
            }}
        >
            <span style={{ position: 'relative', zIndex: 1, display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                {isSelected && <Sparkles size={16} color="currentColor" />}
                {interest}
            </span>
        </Button>
    );
};

export default InterestEditPill;

